// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__2RtuN","info":"UpdateTermsInfo_info__3lC3L"};